
import { Dropdown, Menu, Pagination, Popconfirm, Table, Tag, Tooltip } from "antd";
import moment from "moment";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { CiMenuKebab, CiRead } from "react-icons/ci";
import { useSelector } from "react-redux";
import { GoBlocked } from "react-icons/go";

function DataTable(props: any) {
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.User.user);
  const Events = useSelector((state: any) => state.Events);

  const columns: any = [
    {
      title: "Corporate",
      dataIndex: "investor_name",
      key: "investor_name",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (val: any, record: any) => {
        return (
          <div>
            {record?.investors?.company}
            <div className="DashboardScreen-text3">{record?.investor_name}</div>
          </div>
        );
      },
    },
    {
      title: "Corporate Status",
      dataIndex: "corporate_status",
      key: "corporate_status",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (val: any, record: any) => {
        if (record?.vc_checkout) {
          return (
            <Tag color="red" style={{ minWidth: 110, textAlign: "center" }}>
              Checked Out
            </Tag>
          );
        } else if (record?.vc_checkin) {
          return (
            <Tag color="green" style={{ minWidth: 110, textAlign: "center" }}>
              Checked In
            </Tag>
          );
        } else {
          return (
            <Tag color="#cfc89b" style={{ minWidth: 110, textAlign: "center" }}>
              Not yet
            </Tag>
          );
        }
      },
    },
    {
      title: "Time Slot",
      dataIndex: "slot",
      key: "slot",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: "Room",
      dataIndex: "meeting_room",
      key: "meeting_room",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (val: any, record: any) => (
        <div>{record?.investors?.meeting_room}</div>
      ),
    },
    {
      title: "Startup",
      dataIndex: "startup_name",
      key: "startup_name",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: "Startup Status",
      dataIndex: "startup_status",
      key: "startup_status",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (val: any, record: any) => {
        if (record?.su_checkout) {
          return (
            <Tag color="red" style={{ minWidth: 110, textAlign: "center" }}>
              Checked Out
            </Tag>
          );
        } else if (record?.su_checkin) {
          return (
            <Tag color="green" style={{ minWidth: 110, textAlign: "center" }}>
              Checked In
            </Tag>
          );
        } else {
          return (
            <Tag color="#cfc89b" style={{ minWidth: 110, textAlign: "center" }}>
              Not yet
            </Tag>
          );
        }
      },
    },
    {
      title: "Meeting Status",
      dataIndex: "meeting_status",
      key: "meeting_status",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (val: any, record: any) => {
        if (record?.status === false) {
          return (
            <Tag color="red" style={{
              minWidth: 110,
              textAlign: "center",
              color: "white",    
              backgroundColor: "red",
              border: "1px solid red", 
            }}>
              Meeting Cancelled
            </Tag>
          );
        }
        if (record?.meeting_end) {
          return (
            <Tag color="red" style={{ minWidth: 110, textAlign: "center" }}>
              Ended
            </Tag>
          );
        } else if (record?.meeting_start) {
          return (
            <Tag
              color="green-inverse"
              style={{ minWidth: 110, textAlign: "center" }}
            >
              Started
            </Tag>
          );
        } else {
          return (
            <Tag color="#cfc89b" style={{ minWidth: 110, textAlign: "center" }}>
              Not yet started
            </Tag>
          );
        }
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (item: any) => (
        <div style={{ fontSize: 12 }}>{moment(item).format("MMM D, YYYY h:mm:ss A")}</div>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (item: any) => (
        <div style={{ fontSize: 12 }}>{moment(item).format("MMM D, YYYY h:mm:ss A")}</div>
      ),
    },
    {
      title: "Created By",
      dataIndex: "created_by",
      key: "created_by",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: "Updated By",
      dataIndex: "updated_by",
      key: "updated_by",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: "Actions",
      width: 30,
      onCell: (record: any) => ({
        onClick: (event: any) => handleCellClick(event, "Actions", record),
      }),
      render: (item: any, record: any) => {
        const isActive = record?.status === true;
        const isDisabled = !isActive;
        const menu = (
          <Menu>
            <Menu.Item key="update">
            <Popconfirm
                title="Cancel"
                description="Are you sure to cancel this meeting?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => props?.updateStatus(record?.id, user.name)}
                disabled={isDisabled}
              >
                <div className="flex items-center gap-1 text-red-500 me-1">
                  <GoBlocked size={20} color="orange" /> Cancel 
                  </div>
                </Popconfirm>
           
            </Menu.Item>
            <Menu.Item key="delete">
              <Popconfirm
                title="Delete"
                description="Are you sure to delete this?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => props?.delete(record?.id)}
                disabled={isDisabled}
              >
                <div className="flex items-center gap-1 text-red-500 me-1">
                  <IoIosCloseCircleOutline size={20} color="red"/> Delete
                </div>
              </Popconfirm>
            </Menu.Item>
          </Menu>
        );

        return (
          <div className="table-item">
            <div
              onClick={() => {
                if (!isActive) return;
                navigate(`/company/meetings/${item.uuid}`);
              }}
              style={{ opacity: isDisabled ? 0.5 : 1, cursor: isDisabled ? "not-allowed" : "pointer" }}
            >
              <Tooltip placement="top" title={<div style={{ fontSize: 10 }}>{isDisabled ? "Details disabled" : "Meeting Details"}</div>}>
                <CiRead size={25} color={isDisabled ? "#aaa" : "#000"} />
              </Tooltip>
            </div>
            {Array.isArray(user.access[Events?.defult?.id]) &&
            user.access[Events?.defult?.id].includes(8) ? null : (
              isDisabled ? (
                <span style={{ opacity: 0.5, cursor: "not-allowed" }}>
                  <CiMenuKebab size={20} />
                </span>
              ) : (
                <Dropdown overlay={menu} trigger={["click"]}>
                  <CiMenuKebab size={20} className="cursor-pointer" />
                </Dropdown>
              )
            )}
          </div>
        );
      },
    },
  ];

  const handleRowClick = (item: any) => {
    const isActive = item?.status === true;
    if (!isActive) return;
    navigate(`/company/meetings/${item.uuid}`);
  };

  const handleCellClick = (event: any, column: any, record: any) => {
    if (column !== "Actions") {
      const isActive = record?.status === true;
      if (!isActive) {
        event?.stopPropagation?.();
        return;
      }
      handleRowClick(record);
    } else {
      event.stopPropagation();
    }
  };

  // Handle table sorting - all sorting is now handled by backend
  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let sortBy = '';
    let sortOrder = '';
    
    if (sorter && sorter.field) {
      sortBy = sorter.field;
      sortOrder = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : '';
    }
    
    // Call parent component's sorting handler for all columns
    props?.onSortChange && props.onSortChange(sortBy, sortOrder);
  };

  return (
    <>
      <Table
        size="small"
        tableLayout="fixed"
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
        })}
        style={{ cursor: "pointer" }}
        dataSource={props?.data || []}
        columns={columns}
        pagination={false}
        loading={props?.loading}
        scroll={{ x: 'max-content' }}
        onChange={handleTableChange}
        showSorterTooltip={false}
      />
      <br />
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Pagination
          total={props?.meta?.total_count}
          showSizeChanger
          showTotal={(total: any) =>
            `Total ${props?.meta?.total_count} Meetings`
          }
          onChange={(page, pageSize) => props.onPageChange(page, pageSize)}
          defaultCurrent={props?.meta?.page}
          defaultPageSize={props?.meta?.take}
        />
      </div>
    </>
  );
}

export default DataTable;